import * as THREE from 'three'
import type { LightConfig } from './types'

export class LightingManager {
  private lights: THREE.Light[] = []

  constructor(private scene: THREE.Scene, config?: LightConfig) {
    this.setup(config)
  }

  private setup(config?: LightConfig) {
    const {
      ambientColor = 0xffffff,
      ambientIntensity = 0.8,
      directionalColor = 0xffffff,
      directionalIntensity = 1.2,
      directionalPosition = { x: 5, y: 10, z: 5 },
      enableShadow = true,
    } = config || {}

    const ambient = new THREE.AmbientLight(ambientColor, ambientIntensity)
    this.scene.add(ambient)
    this.lights.push(ambient)

    const hemi = new THREE.HemisphereLight(0xffffff, 0x444444, 0.6)
    this.scene.add(hemi)
    this.lights.push(hemi)

    const directional = new THREE.DirectionalLight(directionalColor, directionalIntensity)
    directional.position.set(directionalPosition.x, directionalPosition.y, directionalPosition.z)
    if (enableShadow) {
      directional.castShadow = true
      directional.shadow.mapSize.width = 1024
      directional.shadow.mapSize.height = 1024
      directional.shadow.camera.near = 0.1
      directional.shadow.camera.far = 30
      directional.shadow.camera.left = -8
      directional.shadow.camera.right = 8
      directional.shadow.camera.top = 8
      directional.shadow.camera.bottom = -8
      directional.shadow.bias = -0.005
      directional.shadow.normalBias = 0.05
    }
    this.scene.add(directional)
    this.lights.push(directional)

    const fill = new THREE.DirectionalLight(0xffffff, 0.6)
    fill.position.set(-directionalPosition.x, directionalPosition.y * 0.5, -directionalPosition.z)
    this.scene.add(fill)
    this.lights.push(fill)
  }

  addLight(light: THREE.Light) {
    this.scene.add(light)
    this.lights.push(light)
  }

  clear() {
    this.lights.forEach(l => this.scene.remove(l))
    this.lights = []
  }
}
